// src/components/organisms/cart/free-shipping/index.js

export { default } from './FreeShipping'
